export default class BeforeUnloadListener {
  private readonly eventListener: () => void;

  constructor(eventHandler: () => void) {
    this.eventListener = eventHandler;
    window.addEventListener('beforeunload', this.eventListener, false);
  }

  destroy() {
    window.removeEventListener('beforeunload', this.eventListener, false);
  }
}
